import { routes } from "routes";
import { Container, H1, P500, SubHeader } from "./StaticPagesComponents";
import React, { Fragment } from "react";
import { FooterAds } from "../../components/ads/FooterAds";

export const GuidelinesPage = () => {

  return (
    <Fragment>
      <Container className="page narrow">
        <H1>
          RedGIFs Use Community Guidelines
        </H1>

        <P500>
          All users of RedGIFs.com must comply with our
          <a href={routes.terms()}> Terms of Service </a>
          swhich places restrictions on how you can use such Services.
          In these Guidelines we will provide additional information on how the site can and should be used as well as how we deal
          with users/content that go against our Terms of Service.
        </P500>

        <SubHeader>
          1. Content
        </SubHeader>

        <P500>
          All content (images, video and text) that is uploaded to RedGIFs.com must comply with our terms of service.
          Below we explain in full how to properly interpret and comply with those Terms.
        </P500>

        <SubHeader>
          1.1 Content Restrictions
        </SubHeader>

        <P500>
          Users may not upload content that:
        </P500>

        <P500>
          • Contains anyone under the age of 18 <br />
          • Depicts Racist acts, signs or language <br />
          • Contains Animals and/or acts of Bestiality <br />
          • Depicts or simulates Rape and/or Sexual Assault <br />
          • Contains acts of violence/self-harm <br />
          • Is defamatory <br />
          • Promotes terrorism, violence, hate speech <br />
          • Violates any law
        </P500>

        <SubHeader>
          1.2 Copyright
        </SubHeader>

        <P500>
          Before you submit any content, you must ensure that you have all necessary rights to do so.
          You must either own the content, have obtained appropriate licenses, or have some other clear legal basis to upload it.
          <br /><br />
          Uploading infringing materials may expose you to legal liability and could result in the
          termination of your account in accordance with our <a href={routes.terms()}>Terms of Service</a>.
        </P500>

        <SubHeader>
          1.3 Screen Name, Profile Picture and Avatar
        </SubHeader>

        <P500>
          You may not use screen names, profile pictures or avatars that are offensive (e.g., names with explicit language),
          depict any nudity, display symbols associated with gangs, hate groups, or terror organizations, or violate the content
          restrictions in Section 1.1 and 1.2 above.
        </P500>

        <SubHeader>
          2. Restricted Users
        </SubHeader>

        <P500>
          Certain users may not use our services, regardless of their content. These are: gangs, hate groups, terror organizations,
          members of the foregoing, persons who are subject to U.S. sanctions and persons under the age of 18.
        </P500>

        <SubHeader>
          3. Conduct
        </SubHeader>

        <P500>
          Our <a href={routes.terms()}>Terms of Service</a> clearly and fully lay out rules that explicitly disallow
          our users from (among other things)
          harassing other users, interfering with our technical measures, spamming, or engaging in inauthentic behaviour. “Spamming” includes mass
          distribution of the same or similar content, content containing links intended to sell the user some dubious item, and the use of bots,
          scripts, or other automated tools for any purpose. “Inauthentic behaviour” includes creating fake accounts, liking or commenting on your
          own content using another account, and purchasing likes or comments from third-parties
        </P500>

        <SubHeader>
          4. Reporting Suspected Violations
        </SubHeader>

        <P500>
          If you see any content and/or user accounts that violate our terms of service and the guidelines set forth
          in articles 1.1, 1.2, 1.3, 2 and 3
          then you may report individual GIFs by flagging it through the ‘report’ function visible on all pieces of content.
          <br /><br />
          To file a DMCA notice, please follow the instructions found on our <a href={routes.dmca()}>DMCA</a> page.
          <br /><br />
          To report a user account or for any additional issues, please email
          <a href={"mailto:support@redgifs.com?subject=Report%20of%20violations"}> support@redgifs.com </a>
          and clearly describe the issue and provide the appropriate links.
        </P500>

        <SubHeader>
          5. Enforcement
        </SubHeader>

        <P500>
          We endeavour to review all pieces of content and accounts flagged by our users and third parties.
        </P500>

        <SubHeader>
          5.1 Removals and Terminations
        </SubHeader>

        <P500>
          Violations may result in suspension or removal of videos, account privileges, or your entire account.
          Account removal will occur in severe cases, such as where you have wilfully or repeatedly violated our
          terms or have uploaded extremely inappropriate content. If your account is permanently removed, you may not create a new account.
          <br /><br />
          In some cases, dependent on the reason for the content/profile removal, the appropriate authorities will
          be notified and all offending content shared with them.
          <br /><br />
          If you believe your content and/or account has been removed without due reason then please email
          <a href={"mailto:support@redgifs.com?subject=Account%20removal"}> support@redgifs.com </a> and
          make a request for the decision to be reconsidered.
        </P500>

        <SubHeader>
          6. Legal Effect
        </SubHeader>

        <P500>
          These Guidelines provide our definitive views on our restrictions, but are not meant to be exhaustive and
          shall not be construed to impose limitations or obligations on RedGIFs that do not appear in our Terms of Service.
          We may, from time to time, update our Guidelines to provide guidance on new situations that may arise.
        </P500>

      </Container>

      <FooterAds/>
    </Fragment>
  );

};
